import { useCallback, useState } from "react";
import { useForm } from "@kanda-libs/ks-component-ts";
import type { StringIndexedObject } from "@kanda-libs/ks-component-ts";
import { actions } from "@kanda-libs/ks-frontend-services";
import { useToast } from "@kanda-libs/ks-design-library";
import { useHistory } from "react-router-dom";
import { useAppDispatch } from "components/shared/App";
import { URLS } from "components/shared/App/constants";
import { DEFAULT_VALUES } from "./constants";
import { formatStaffOnboardBody } from "./helpers";

export default function useAddCompanyPage() {
  const form = useForm<StringIndexedObject>({
    mode: "onBlur",
    defaultValues: DEFAULT_VALUES,
  });
  const dispatch = useAppDispatch();
  const { push } = useHistory();
  const { showSuccess, showError } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = useCallback(
    (values: StringIndexedObject) => {
      const body = formatStaffOnboardBody(values);
      setIsLoading(true);
      dispatch(
        actions.postCompanyStaffOnboard({
          body,
          onSuccess: () => {
            setIsLoading(false);
            showSuccess("Company created");
            push(URLS.companies);
          },
          onError: () => {
            setIsLoading(false);
            showError("Failed to create company");
          },
        }),
      );
    },
    [dispatch, push, showSuccess, showError],
  );

  return { form, onSubmit, isLoading };
}
